import React from 'react'

const NotFound = () => {
  return (
    <div>
       <div className="h-screen flex flex-col items-center justify-center bg-gray-200">
       <div className='relative flex flex-col items-center w-300 justify-center p-10 pl-20 pr-20 bg-white shadow-2xl rounded-tr-3xl rounded-3xl border-[2px] border-[#ff9906]'>
            {/* Top-left corner */}
            <div className="absolute top-0 left-0 w-4 h-4 bg-[#ff9906] rounded-tl-md"></div>
            {/* Top-right corner */}
            <div className="absolute top-0 right-0 w-4 h-4 bg-[#ff9906] rounded-tr-md"></div>
            {/* Bottom-left corner */}
            <div className="absolute bottom-0 left-0 w-4 h-4 bg-[#ff9906] rounded-bl-md"></div>
            {/* Bottom-right corner */}
            <div className="absolute bottom-0 right-0 w-4 h-4 bg-[#ff9906] rounded-br-md"></div>

            <h1 className="mb-4 text-6xl font-semibold text-red-500">404</h1>
            <p className="mb-4 text-lg text-gray-600">Oops! Looks like you're lost.</p>
            <div className="animate-bounce">
                <svg className="mx-auto h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                </svg>
            </div>
            <span className="mt-4 text-gray-600">
                Sorry! Page is not found. Let's get you back <a href="/" className="text-[#ff9906] border-b-[2px] border-[#ff9906]">Home</a>.
            </span>
        </div>
        </div>
    </div>
  )
}

export default NotFound
